/**
 * TeenPattiHandRanking — Hand rank display and reference guide.
 */
import React from 'react';
import { TeenPattiHandRankingProps } from '../types';
import './TeenPattiHandRanking.css';

const RANKING_GUIDE = [
  { rank: 'Trail', desc: 'Three of a Kind (e.g., A-A-A)', emoji: '🏆' },
  { rank: 'Pure Sequence', desc: 'Straight Flush (e.g., A♠-K♠-Q♠)', emoji: '💎' },
  { rank: 'Sequence', desc: 'Straight (e.g., A-K-Q)', emoji: '📈' },
  { rank: 'Color', desc: 'Flush (e.g., K♥-J♥-8♥)', emoji: '🎨' },
  { rank: 'Pair', desc: 'Two of a Kind (e.g., K-K-7)', emoji: '👯' },
  { rank: 'High Card', desc: 'Highest card wins (e.g., A-10-5)', emoji: '🃏' },
];

const TeenPattiHandRanking: React.FC<TeenPattiHandRankingProps> = ({
  handResult, showRankingGuide = false,
}) => {
  return (
    <div className="tp-hand-ranking" role="region" aria-label="Hand ranking">
      {handResult && (
        <div className="tp-hand-ranking__current">
          <span className="tp-hand-ranking__label">Your Hand:</span>
          <span className="tp-hand-ranking__value">{handResult.rankName}</span>
        </div>
      )}
      {showRankingGuide && (
        <div className="tp-hand-ranking__guide">
          <h4 className="tp-hand-ranking__guide-title">Hand Rankings</h4>
          <ol className="tp-hand-ranking__list">
            {RANKING_GUIDE.map((item, i) => (
              <li
                key={item.rank}
                className={`tp-hand-ranking__item ${handResult && i === (5 - handResult.rank) ? 'tp-hand-ranking__item--active' : ''}`}
              >
                <span className="tp-hand-ranking__emoji">{item.emoji}</span>
                <span className="tp-hand-ranking__name">{item.rank}</span>
                <span className="tp-hand-ranking__desc">{item.desc}</span>
              </li>
            ))}
          </ol>
        </div>
      )}
    </div>
  );
};

export { TeenPattiHandRanking };
export default TeenPattiHandRanking;
